import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
var _excluded = ["as", "src", "background", "altText", "gatsbyImageProps", "children"];
/* eslint-disable react/forbid-prop-types */

import React from 'react';
import { Image as SemanticUIImage } from 'semantic-ui-react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { BgImage } from 'gbimage-bridge';
import _isEmpty from 'lodash/isEmpty';
import { ChildrenPropType } from '../../services/proptypes';
import { isGatsbyImage, isOldGatsbyImage } from '../../utils/gatsby';
import ImageOld from './components/ImageOld';

var Image = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Image, _React$PureComponent);

  function Image() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = Image.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        as = _this$props.as,
        src = _this$props.src,
        background = _this$props.background,
        altText = _this$props.altText,
        gatsbyImageProps = _this$props.gatsbyImageProps,
        children = _this$props.children,
        extraProps = _objectWithoutPropertiesLoose(_this$props, _excluded);

    if (_isEmpty(src)) {
      return null;
    }

    if (isOldGatsbyImage(src)) {
      return /*#__PURE__*/React.createElement(ImageOld, this.props);
    }

    if (isGatsbyImage(src)) {
      var image = getImage(src);

      var allGatsbyImageProps = _extends({}, extraProps, gatsbyImageProps, {
        image: image,
        alt: altText
      });

      if (background) {
        return /*#__PURE__*/React.createElement(BgImage, _extends({
          image: image,
          Tag: as
        }, allGatsbyImageProps), children);
      }

      return /*#__PURE__*/React.createElement(GatsbyImage, allGatsbyImageProps);
    } // Handle simple URL image


    if (background) {
      return /*#__PURE__*/React.createElement(as, _extends({}, extraProps, {
        style: _extends({
          backgroundImage: "url('" + src + "')",
          backgroundPosition: 'center',
          backgroundSize: 'cover'
        }, extraProps.style)
      }), children);
    }

    return /*#__PURE__*/React.createElement(SemanticUIImage, _extends({}, extraProps, {
      src: src,
      alt: altText
    }));
  };

  return Image;
}(React.PureComponent);

export default Image;
Image.defaultProps = {
  as: 'div',
  src: '',
  background: false,
  altText: '',
  gatsbyImageProps: null,
  children: null
};